import { Component, Input, OnInit, ViewChild } from '@angular/core';
import _ from 'lodash';
import { PageFavoriteService } from '../../../../../services/page-favorite.service';
import { PageFavorite } from '../../../../../models/page-favorite';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalService } from '../../../../../services/modal.service';
import { DisabledFeatureModalable } from '../../../../../models/disabled-feature-modalable';
import { AssetPipe } from '../../../../../pipes/asset.pipe';

@Component({
    selector: 'app-page-favorite',
    templateUrl: './page-favorite.component.html',
    styleUrls: ['./page-favorite.component.scss'],
    standalone: true,
    imports: [
        AssetPipe
    ]
})
export class PageFavoriteComponent implements OnInit {

    @Input() page;
    @Input() isLeft: boolean;
    @ViewChild('bookmark') bookmark;
    isActive: boolean | PageFavorite;
    isOnline = true;
    debouncedUpdate = _.debounce(this.updateBookmark, 300);
    createdId: number;

    constructor(private applicationStateService: ApplicationStateService,
                private pageFavoriteService: PageFavoriteService,
                private modalService: ModalService) {
    }

    ngOnInit(): void {
        this.isOnline = !this.applicationStateService.isOfflineModeEnabled;
        this.pageFavoriteService.getPageFavorites().then(result => {
            this.isActive = _.find(result, { pageId: this.page.id, assignmentSlug: null });
            if (this.isActive) {
                this.createdId = (this.isActive as PageFavorite).id;
            }
        });
    }

    onClick(): void {
        this.debouncedUpdate();
    }

    updateBookmark(): void {

        if (this.isActive) {
            this.unbookmarkPage();
        } else {
            this.bookmarkPage();
        }
    }

    bookmarkPage(): void {

        if (!this.applicationStateService.bookConfig.bookPermissions.pageFavorite.create) {
            const disabledFeatureModal = new DisabledFeatureModalable();
            disabledFeatureModal.type = ModalService.PAGE_FAVORITE;
            disabledFeatureModal.iconUrl = 'icon-lesezeichen-active.png';
            this.modalService.openModal(disabledFeatureModal);

            return;
        }

        const pageFavorite = new PageFavorite();
        pageFavorite.pageId = this.page.id;
        pageFavorite.index = this.page.index;
        if (!this.createdId) {
            this.isActive = true;
            this.pageFavoriteService.createPageFavorite(pageFavorite)
                .then(favorite => this.createdId = favorite.id);
        }
    }

    unbookmarkPage(): void {
        if (this.createdId) {
            this.isActive = false;
            this.pageFavoriteService.getPageFavorites().then(result => {
                const ele: undefined | PageFavorite = _.find(result, {
                    pageId: this.page.id,
                    assignmentSlug: null
                });
                if (ele) {
                    this.pageFavoriteService.deletePageFavorite(ele).then(() => this.createdId = null);
                }
            });
        }
    }

    onKeyDown($event: KeyboardEvent): void {
        if ($event.key !== 'Enter' && $event.key !== 'Space') {
            return;
        }

        this.onClick();
    }
}
